import {type CardEnum, type CardTypeEnum, PlayerColor, type PlayerState} from '@colonist/game-states'
import {CardDataController} from '@colonist/game-card-types'

export const STARTING_SETTLEMENT_AMOUNT = 5

export function getInitialPlayerState(playerColor: PlayerColor, isConnected: boolean, cardDiscardLimit: number, activeResourceCardTypes?: CardTypeEnum[]): PlayerState {
    return {
        color: playerColor,
        victoryPointsState: {},
        bankTradeRatiosState: getDefaultBankTradeRatiosState(activeResourceCardTypes),
        resourceCards: {cards: []},
        cardDiscardLimit: cardDiscardLimit,
        isConnected: isConnected,
        isTakingAction: false,
    }
}

function getDefaultBankTradeRatiosState(activeResourceCardTypes?: CardTypeEnum[]): {[key in CardEnum]?: number} {
    if(activeResourceCardTypes == undefined) return {}
    const defaultTradeRatio = 4
    const activeResourceCards = CardDataController.getCardEnumsOfTypes(activeResourceCardTypes)
    const bankTradeRatiosState: {[key in CardEnum]?: number} = {}
    activeResourceCards.forEach((cardEnum) => bankTradeRatiosState[cardEnum] = defaultTradeRatio)
    return bankTradeRatiosState
}

export function getEmptyPlayerState(): PlayerState {
    return getInitialPlayerState(PlayerColor.None, true, 7, []) // TODO: Check if setting DeviceType to web causes bugs
}
